import _ from 'lodash';
import { translate, translateText } from '../../../../scripts/core/tools/translate';
import environment from '../../../../scripts/environment';
import api from '../../../../scripts/api';
import { FeaturePermission } from '../../../../constants/feature.permission.helper';
import { VehicleTypeEnum } from '../../../../scripts/core/vehicleType/constants';
const isAuthorized = (permission, feature) => api.authorization.isAuthorized(permission, feature);

export class ClusterSalesFactory {
    constructor ({ options, currentMap }) {
        this.options = options;
        this.currentMap = currentMap;
    }

    getData () {
        const data = [];

        if (!this.options.fields) {
            return data;
        }

        if (this.options.fields.segments) {
            data.push({
                name: 'segments',
                data: _.reduce(environment.get('CONFIG.FILTERS.COMPETING_SEGMENTS'), (acc, val, key) => {
                    _.forEach(val, (v) => {
                        acc.push({
                            CD_CAT: key,
                            NM_CAT: key === 'competing' ? 'Competing' : 'Non Competing',
                            CD_SEGMENT: v.id,
                            NM_SEGMENT: translateText(v.nome, true)
                        });
                    });

                    return acc;
                }, []),
                position: 1,
                visible: isAuthorized(FeaturePermission.LAYER_CLUSTER_SALES.filterSegment),
                fields: [{
                    title: `${translate('Common.Classification')} ${translate('Common.Segment')}`,
                    name: 'competingClassification',
                    value: 'CD_CAT',
                    text: 'NM_CAT',
                    skipAll: true,
                    type: 'multiselect'
                }, {
                    title: translate('Common.Segments'),
                    name: 'models',
                    value: 'CD_SEGMENT',
                    text: 'NM_SEGMENT',
                    group: 'NM_CAT',
                    type: 'multiselect',
                    skipAll: true
                }]
            });
        }

        if (this.options.fields.brands) {
            if (_.isObject(this.options.fields.brands) && !this.options.fields.brands.visible) {
                return data;
            }

            const filter = {
                name: 'category_and_brands',
                data: environment.get('CONFIG.FILTERS.BRANDS'),
                position: 2,
                visible: isAuthorized(FeaturePermission.LAYER_CLUSTER_SALES.filterBrand),
                fields: [{
                    title: translate('Common.Brand'),
                    name: 'brands',
                    value: 'brand',
                    text: 'brand',
                    type: 'multiselect'
                }]
            };

            if (environment.get('CONFIG.USERVEHICLETYPE') === VehicleTypeEnum.Car) {
                filter.fields.unshift({
                    title: `${translate('Common.Classification')} ${translate('Common.Brand')}`,
                    name: 'classification',
                    value: 'classificationId',
                    text: 'classification',
                    skipAll: true,
                    type: 'multiselect'
                });
            }

            data.push(filter);
        }
        if (this.options.fields.groups) {
            data.push({
                name: 'group',
                position: 4,
                visible: isAuthorized(FeaturePermission.LAYER_CLUSTER_SALES.filterGroup),
                fields: [{
                    title: translate('Common.Group'),
                    name: 'group',
                    dataSource: _(environment.get('CONFIG.FILTERS.GROUPS_NAME'))
                        .orderBy(val => val.text)
                        .value(),
                    value: 'value',
                    text: 'text',
                    skipAll: true,
                    type: 'multiselect'
                }]
            });
        }

        if (this.options.fields.fuelTypes) {
            data.push({
                name: 'fuelTypes',
                position: 5,
                visible: isAuthorized(FeaturePermission.LAYER_CLUSTER_SALES.filterFuelType),
                fields: [{
                  title: translate('Common.FuelType'),
                  name: 'fuelTypes',
                  dataSource: _.map(environment.get('CONFIG.FILTERS.FUEL_TYPES'), (fuel) => ({ text: fuel.text, value: fuel.value })),
                  value: 'value',
                  text: 'text',
                  skipAll: true,
                  type: 'multiselect'
                }]
              });
        }

        if (environment.get('CONFIG.FILTERS.SPECIALIZATION_INDUSTRY_CONTEXT')
            && environment.get('CONFIG.FILTERS.SPECIALIZATION_INDUSTRY_CONTEXT').length) {
            data.push({
                name: 'industry',
                position: 6,
                visible: true,
                fields: [{
                    title: translate('Common.Industry'),
                    name: 'industry',
                    dataSource: environment.get('CONFIG.FILTERS.SPECIALIZATION_INDUSTRY_CONTEXT'),
                    value: 'id',
                    text: 'name',
                    type: 'dropdown'
                }]
            });
        }

        return data.filter(c => c.visible);
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/filters/factory/clusterSales.factory.js